export class PedidoConstants {
  static readonly CHAVE_PEDIDO_LOCAL_STORAGE:string = "Pedido-{numeroPedido}";
}
